module.exports = __webpack_public_path__ + "static/media/C3.9d878045.jpg";